const BigQueryEventTypes = {
    translation: {
        clickedOnTranslationButton: 'clicked_on_translation_button',
        clickedOnCancelledTranslationButton: 'clicked_on_cancelled_translation_button'
    }
};

module.exports = {
    BigQueryEventTypes
};
